import type { IconNode } from '../types';

/**
 * @name spider-web
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTcuMlY2LjhMMTIgMiAzIDYuOHYxMC40bDkgNC44WiIgLz4KICA8cGF0aCBkPSJNMiAxNy44IDIyIDYuMiIgLz4KICA8cGF0aCBkPSJtMiA2LjIgMjAgMTEuNiIgLz4KICA8cGF0aCBkPSJNMTIgMnYyMCIgLz4KICA8cGF0aCBkPSJNMTcgMTQuOVY5LjFsLTUtMi42LTUgMi42djUuOGw1IDIuNloiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/spider-web
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const spiderWeb: IconNode = [
  ['path', { d: 'M21 17.2V6.8L12 2 3 6.8v10.4l9 4.8Z', key: '1sisf0' }],
  ['path', { d: 'M2 17.8 22 6.2', key: 'f0ffhb' }],
  ['path', { d: 'm2 6.2 20 11.6', key: '13je75' }],
  ['path', { d: 'M12 2v20', key: 't6zp3m' }],
  ['path', { d: 'M17 14.9V9.1l-5-2.6-5 2.6v5.8l5 2.6Z', key: '1dbhce' }],
];

export default spiderWeb;
